export default __webpack_public_path__ + "static/key-findings-figure-4b-2025-56563f7f71495ee275fa969148c0e495.png";